import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { syncEngine } from './lib/offline/sync'
import { surveySyncEngine } from './lib/services/surveySync'
import { registerFieldAppServiceWorker } from './lib/fieldAppPwa'
import { resolveUnexpectedHostRedirect } from './lib/fieldAppHost'

// Polyfill crypto.randomUUID for non-secure contexts (HTTP dev server on mobile)
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = () =>
    '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c: string) =>
      (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
    ) as `${string}-${string}-${string}-${string}-${string}`
}

const unexpectedHostRedirect = resolveUnexpectedHostRedirect()

if (unexpectedHostRedirect) {
  window.location.replace(unexpectedHostRedirect)
} else {
  // F-04: sync engines may start for online listeners, but both refuse work
  // until AuthProvider binds offlineStore active owner (no pre-auth PHI replay).
  syncEngine.start()
  surveySyncEngine.start()
  registerFieldAppServiceWorker()

  ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
          <App />
      </React.StrictMode>,
  )
}
